var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.71483 12.1896C7.32862 11.7948 6.6955 11.7878 6.30071 12.1741C5.90591 12.5603 5.89896 13.1934 6.28517 13.5882L7.71483 12.1896ZM10.0435 16L9.32864 16.6993C9.5239 16.8989 9.79371 17.0078 10.0728 16.9996C10.3519 16.9914 10.6149 16.8669 10.7981 16.6562L10.0435 16ZM17.7546 8.65618C18.117 8.23942 18.0729 7.60779 17.6562 7.24539C17.2394 6.883 16.6078 6.92706 16.2454 7.34382L17.7546 8.65618ZM6.28517 13.5882L9.32864 16.6993L10.7583 15.3007L7.71483 12.1896L6.28517 13.5882ZM10.7981 16.6562L17.7546 8.65618L16.2454 7.34382L9.28887 15.3438L10.7981 16.6562Z",
    fill: "currentColor"
  })));
}
export default SvgCheckMark;